'use client';

import Image from 'next/image';

export default function ProductImage({ src, alt, width, height, className, ...props }) {
  const isExternal = src && (src.startsWith('http://') || src.startsWith('https://'));
  const isVercelBlob = src && src.includes('blob.vercel-storage.com');

  if (isVercelBlob || (isExternal && !src.includes('unsplash') && !src.includes('apple.com'))) {
    return (
      <img
        src={src}
        alt={alt}
        width={width}
        height={height}
        className={className}
        {...props}
      />
    );
  }

  return (
    <Image
      src={src}
      alt={alt}
      width={width}
      height={height}
      className={className}
      {...props}
    />
  );
}
